// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1susJ","fullView":"styles_fullView__1oelu"};